import {Injectable} from '@angular/core';
import {AuthenticationService} from '../_shared/services/authentication.service';
import {Http} from '@angular/http';
import {environment} from '../../environments/environment';
import {Folder} from './folder';

@Injectable()
export class FolderService {
    url = `${environment.apiUrl}/inode/`;

    constructor(private http: Http,
                private authService: AuthenticationService) {
    }

    getRootFolders() {
        return this.http.get(this.url, this.authService.getAuthOptions())
            .map(res => res.json());
    }

    getFolderFolders(folderId: number) {
        const url = `${this.url}?parent=${folderId}`;
        return this.http.get(url, this.authService.getAuthOptions())
            .map(res => res.json());
    }

    get(id: number) {
        const url = `${this.url}${id}/`;
        return this.http.get(url, this.authService.getAuthOptions())
            .map(res => res.json());
    }

    getTree(id: Number) {
        const url = `${this.url}${id}/tree/`;
        return this.http.get(url, this.authService.getAuthOptions())
            .map(res => res.json());
    }

    delete(id: number) {
        const url = `${this.url}${id}/`;
        return this.http.delete(url, this.authService.getAuthOptions())
            .map(res => res.json());
    }

    create(folder: Folder) {
        return this.http.post(this.url, JSON.stringify(folder), this.authService.getAuthOptions())
            .map(res => res.json());
    }

    update(folder: Folder) {
        const url = `${this.url}${folder.id}/`;
        return this.http.put(url, JSON.stringify(folder), this.authService.getAuthOptions())
            .map((res) => res.json());
    }

    getFoldersTree() {
        const url = `${this.url}full_tree/`;
        return this.http.get(url, this.authService.getAuthOptions())
            .map(res => res.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/folder/folder.service.ts